﻿/**
 * CONTENT LOAD SELECTOR BLOCK
 *
 * 
 * @class rlContentLoadSelector
 * @memberOf jQuery.fn
 **/

(function ($) {

    $.fn.rlContentLoadSelector = function () {

        ///////////////
        // VARIABLES //
        ///////////////
        const NativeSelect = $('.contentloadselectorblock section.custom-select-wrapper select');


        //////////////////////////////////////////////////
        //Create an unique id on each version on the page
        /////////////////////////////////////////////////
        $('.contentloadselectorblock section.custom-select-wrapper').each(function (index) {
            index + 1;
            $(this).attr('id', 'contentselect' + index);
            $(this).find('h2').attr('id', 'cllsb' + index)
            $(this).children('label').attr('for', 'selectfield' + index);
            $(this).find('select.custom-dropdown-select').attr('id', 'selectfield' + index).attr('name', 'selectfield' + index).attr('aria-labelledby', 'cllsb' + index);            
        });

        ////////////
        // RESETS //
        ////////////

        //clear values on (re)load
        $('.contentloadselectorblock .custom-dropdown-select').val('');

        //reset slide class
        $('.contentloadselectorblock section.custom-select-wrapper .tab-content .tab-panel').hide().removeClass('slide').attr('aria-hidden', 'true');
               

        //////////////////////////////////
        // NATIVE <SELECT> CHANGE EVENT //
        //////////////////////////////////
        NativeSelect.on('change', function () {
           const selectvalue = $(this).val(),
              contentselectid = $(this).parents('.custom-select-wrapper').attr('id');

            $('section#' + contentselectid + ' .tab-content .tab-panel').hide().removeClass('slide').attr('aria-hidden', 'true');
            $('section#' + contentselectid + ' .tab-content .tab-panel[data-content="' + selectvalue + '"]').show().addClass('slide').attr('aria-hidden', 'false');

            //add tabindex for no-touch users only
            $('.no-touchevents section#' + contentselectid + ' .tab-content .tab-panel').removeAttr('tabindex');
            $('.no-touchevents section#' + contentselectid + ' .tab-content .tab-panel[data-content="' + selectvalue + '"]').attr('tabindex', '0');
                       
            const labelby = $(this).parents('.selectcontainer').next('.tab-content').find('.tab-panel.slide').attr('id');
            $(this).attr('aria-describedby', labelby);

        });
               

        //Defect fix for bug 205445
        //iframe bug is resetting the page position in episerver preview mode when interacting with content load dropdowns.
        if (window.location !== window.parent.location) {
            NativeSelect.change(function () {
                const thisid = $(this).parents('.custom-select-wrapper').attr('id');
                setTimeout(function () {
                    document.getElementById(thisid).scrollIntoView();
                }, 1000);
            });
        }
    }

}(jQuery));